import Vue from 'vue';
import Router from 'vue-router';
import Store from '../store';

import routes, { router404 } from './routers.js';
import menu from '@/pages/layout/menu';
import { filterMenu } from '@/utils/util';

Vue.use(Router);

let router = new Router({
    mode: 'history',
    // base: '/app/',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
    routes
});
let flag = true;
router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
        flag = true;
        // Store.commit('updateHasMenu', false)
        // window.location.href = '/login'
        next();
    } else {
        // next({ ...to, replece: true });
        // next();
        // return

        if (!Store.state.hasMenu) {
            flag = false;
            
            Store.dispatch('getMenu')
                .then(() => {

                    let hasDashboard = false;
                    let hasDynamic = false;

                    // Store.state.menuList.forEach(m => {
                    //     m.children && m.children.forEach(c => {
                    //         if (c.path === '/situation') {
                    //             hasDashboard = true
                    //         }
                    //         if (c.path === '/dynamic') {
                    //             hasDynamic = true
                    //         }
                    //     })
                    // })

                    // let routes = filterRouter(
                    //     asyncRouterMap,
                    //     Store.state.menuList
                    // );
                    
                    // router.addRoutes(routes);
                    // if (hasDashboard) {
                    //     router.addRoutes(dashboardRouter);
                    // }
                    // if (hasDynamic) {
                    //     router.addRoutes(dynamicRouter);
                    // }
                    
                    
                    router.addRoutes(router404);

                    Store.commit('updateHasMenu', true)
                    next({ ...to, replece: true });
                })
                .catch(() => {
                    Store.commit('updateHasMenu', false)
                    window.location.href = '/login'
                    // next({ path: '/login' });
                });
        } else {
            next();
        }
    }
});

const filterRouter = (asyncRouter, menu) => {
    asyncRouter.children = asyncRouter.children.filter((item) => {
        return menu.some((i) => {
            if (i.children && i.children.length) {
                return i.children.some((k) => {
                    return k.path === item.path;
                });
            } else {
                return i.path === item.path;
            }
        });
    });

    return [asyncRouter];
};

export default router;
